import { createModuleHttpClient } from '../../createModuleHttpClient';
import knowledgeBaseModule from '../index';

/**
 * Relay client for the knowledge base API. The relay authenticates with the
 * adminToken; read-only access control is handled by the upstream API based
 * on the endpoint called.
 */
const client = createModuleHttpClient(knowledgeBaseModule.id);

export default client;
